import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

// Layouts
import AdminLayout from "./layouts/AdminLayout";
import PartnerLayout from "./layouts/PartnerLayout";

// Public Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import Privacidade from "./pages/Privacidade";
import QRSalePage from "./pages/QRSalePage";

// Admin Pages
import AdminDashboard from "./pages/admin/Dashboard";
import AdminLojas from "./pages/admin/Lojas";
import AdminParceiros from "./pages/admin/Parceiros";
import AdminCampanhas from "./pages/admin/Campanhas";
import AdminCampanhaEditor from "./pages/admin/CampanhaEditor";
import AdminRecompensas from "./pages/admin/Recompensas";
import AdminResgates from "./pages/admin/Resgates";
import AdminVendas from "./pages/admin/Vendas";
import AdminAuditoria from "./pages/admin/Auditoria";
import AdminContas from "./pages/admin/Contas";
import AdminRelatorios from "./pages/admin/Relatorios";
import AdminNiveis from "./pages/admin/Niveis";
import Publicacoes from "./pages/admin/Publicacoes";
import Regulamentos from "./pages/admin/Regulamentos";

// Partner Pages
import PartnerDashboard from "./pages/partner/Dashboard";
import PartnerHistorico from "./pages/partner/Historico";
import PartnerCampanhas from "./pages/partner/Campanhas";
import PartnerRanking from "./pages/partner/Ranking";
import PartnerResgates from "./pages/partner/Resgates";

import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/700.css";
import "./App.css";

const ProtectedRoute = ({ children, allowedTypes }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedTypes && !allowedTypes.includes(user.tipo)) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/p/:codigoParceiro" element={<QRSalePage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute allowedTypes={["master", "admin", "loja"]}>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="lojas" element={<AdminLojas />} />
            <Route path="parceiros" element={<AdminParceiros />} />
            <Route path="campanhas" element={<AdminCampanhas />} />
            <Route path="campanhas/editor" element={<AdminCampanhaEditor />} />
            <Route path="campanhas/editor/:id" element={<AdminCampanhaEditor />} />
            <Route path="recompensas" element={<AdminRecompensas />} />
            <Route path="resgates" element={<AdminResgates />} />
            <Route path="vendas" element={<AdminVendas />} />
            <Route path="relatorios" element={<AdminRelatorios />} />
            <Route path="niveis" element={<AdminNiveis />} />
            <Route path="publicacoes" element={<Publicacoes />} />
            <Route path="regulamentos" element={<Regulamentos />} />
            <Route path="auditoria" element={<AdminAuditoria />} />
            <Route path="contas" element={<AdminContas />} />
          </Route>
          
          {/* Partner Routes */}
          <Route path="/parceiro" element={
            <ProtectedRoute allowedTypes={["parceiro"]}>
              <PartnerLayout />
            </ProtectedRoute>
          }>
            <Route index element={<PartnerDashboard />} />
            <Route path="historico" element={<PartnerHistorico />} />
            <Route path="campanhas" element={<PartnerCampanhas />} />
            <Route path="ranking" element={<PartnerRanking />} />
            <Route path="resgates" element={<PartnerResgates />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
